import { SummaryStatCard } from "../dashboard-summary/SummaryStatCard";
import { Box, Switch, Typography } from "@mui/joy";
import { PieChartWithLegend } from "../SimplePieChart";
import { PieChartProps, VendorAmounts } from "../../utils/types";
import { useEffect, useState } from "react";

export interface IVendorAmounts {
  paid_amount: string;
  pending_amount: string;
  total_amount: string;
  accepted?:any;
  invoice_submitted?:any;
  rejected?:any;
}

const VendorAmountCard = ({ amounts }: { amounts: VendorAmounts }) => {
  const formatCash = (n, isLacs) => {
    if (isLacs) {
      if (n > 100000) return `${(n / 100000).toFixed(1).replace(/\.0$/, "")}L`;
    } else {
      if (n > 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}K`;
    }
    return n;
  };

  const [amountInLacs, setAmountInLacs] = useState<boolean>(false);
  const [formattedAmountsData, setFormattedAmountsData] = useState<any>({
    paid: formatCash(amounts?.paid, amountInLacs),
    accepted: formatCash(amounts?.accepted, amountInLacs),
    invoice_submitted: formatCash(amounts?.invoice_submitted, amountInLacs),
    total: formatCash(amounts?.total, amountInLacs),
    rejected: formatCash(amounts?.rejected, amountInLacs),
  });

  useEffect(() => {
    setFormattedAmountsData({
      paid: formatCash(amounts?.paid, amountInLacs),
      accepted: formatCash(amounts?.accepted, amountInLacs),
      invoice_submitted: formatCash(amounts?.invoice_submitted, amountInLacs),
      total: formatCash(amounts?.total, amountInLacs),
      rejected: formatCash(amounts?.rejected, amountInLacs),
    });
  }, [amountInLacs]);

  const pieChartData: PieChartProps[] = [
    {
      label: "Total Invoices",
      value: amounts?.total,
      arcLabel: formattedAmountsData?.total,
      color: "#0088FE",
    },
    {
      label: "Accepted Invoices",
      value: amounts?.accepted,
      arcLabel: formattedAmountsData?.accepted,
      color: "#00C49F",
    },
    {
      label: "Paid Invoices",
      value: amounts?.paid,
      arcLabel: formattedAmountsData?.paid,
      color: "#FFBB28",
    },
    {
      label: "Rejected Invoices",
      value: amounts?.rejected,
      arcLabel: formattedAmountsData?.rejected,
      color: "#ff4242ff",
    },
    {
      label: "Submitted Invoices",
      value: amounts?.invoice_submitted,
      arcLabel: formattedAmountsData?.invoice_submitted,
      color: "#ff42b7ff",
    },
  ];
  return (
    <div className="container-two">
     
      <>
        <div style={{display: 'flex',gap: '20px',flexWrap: "wrap",justifyContent: 'center'}}>
        <div>
          <SummaryStatCard value={formattedAmountsData?.total} label="Total Amount of All Invoices" valueColor="neutral" />
        </div>
        <div>
          <SummaryStatCard value={formattedAmountsData?.accepted} label="Accepted Invoices Value" valueColor="success" />
        </div>
        <div>
          <SummaryStatCard value={formattedAmountsData?.paid} label="Paid Invoices Value" valueColor="success" />
        </div>
        <div>
            <SummaryStatCard value={formattedAmountsData.rejected} label="Rejected Invoices Value" valueColor="danger" />
          </div>
          <div>
            <SummaryStatCard value={formattedAmountsData.invoice_submitted} label="Submitted Invoices Value" valueColor="danger" />
          </div>
          </div>
        <Box sx={{ p: 2 }}>
          <Typography level="h3" component="h5" textAlign="center" mb={2} className="heading-2">
            Invoices Data (Value)
          </Typography>
           <Switch
                  startDecorator={`Thousands`}
                  endDecorator={`Lacs`}
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    "--Switch-thumbSize": "27px",
                    "--Switch-trackWidth": "64px",
                    "--Switch-trackHeight": "31px",
                  }}
                  checked={amountInLacs}
                  onChange={(e) => setAmountInLacs(e?.target?.checked)}
                />
          <PieChartWithLegend data={pieChartData} />
        </Box>
      </>
    </div>
  );
};

export default VendorAmountCard;
